// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import classNames from 'clsx';
import { memo } from 'react';
import { Icon } from '../icon/index.js';
import { Spinner } from '../spinner/index.js';
import { getButtonClassName } from './classes.js';
export function Button(_a) {
    var { className, color, size, toggled, toggleMode = 'color-and-indicator', align, visuallyDisabled, visuallyFocused, loading, children, disabled, asChild, ref } = _a, props = __rest(_a, ["className", "color", "size", "toggled", "toggleMode", "align", "visuallyDisabled", "visuallyFocused", "loading", "children", "disabled", "asChild", "ref"]);
    const Comp = asChild ? Slot : 'button';
    const buttonProps = Object.assign(Object.assign({ ref: ref }, props), { disabled: disabled || loading, 'data-disabled': visuallyDisabled, 'data-focus': visuallyFocused, 'data-size': size, tabIndex: visuallyDisabled ? -1 : undefined, className: classNames(getButtonClassName({
            color,
            size,
            toggleable: toggled !== undefined &&
                (toggleMode === 'color' || toggleMode === 'color-and-indicator'),
            align,
        }), className) });
    // set state when toggleable
    if (toggled !== undefined) {
        buttonProps['aria-pressed'] = !!toggled;
    }
    if (asChild) {
        // avoid rendering loading spinner with asChild
        return _jsx(Comp, Object.assign({}, buttonProps, { children: children }));
    }
    return (_jsxs(Comp, Object.assign({}, buttonProps, { children: [loading && _jsx(Spinner, { size: 16, className: "inline-block w-1em h-1em" }), toggled !== undefined &&
                (toggleMode === 'indicator' ||
                    toggleMode === 'color-and-indicator') && (_jsx(ToggleIndicator, { value: toggled })), children] })));
}
const ToggleIndicator = memo(function ToggleIndicator({ value, }) {
    return (_jsx(Icon, { "aria-hidden": true, name: "check", className: "transition-width w-0 ml--1", style: {
            width: value ? '15px' : 0,
        } }));
});
//# sourceMappingURL=Button.js.map